import React from 'react';
import { ToastContainer as ReactToastify, toast as createToast } from 'react-toastify';
import classNames from 'classnames/bind';
import 'react-toastify/dist/ReactToastify.min.css';
import styles from './styles.scss';

export class ToastContainer extends React.Component {
  render() {
    return (
      <ReactToastify
        position="bottom-left"
        className={styles.toastContainer}
        progressClassName={styles.progress}
        autoClose={5000}
        closeButton={false}
        role={'alert'}
        icon={false}
      />
    );
  }
}

export function toast(msg, options = { type: 'success' }) {
  options.className = classNames(styles.toast, { [styles[options.type]]: true });

  const path = [];
  switch (options.type) {
    case 'error':
      path['xs'] =
        'M13.4 12L22 3.5c.4-.4.4-1 0-1.4s-1-.4-1.4 0L12 10.6 3.5 2c-.4-.3-1.1-.3-1.5 0s-.4 1 0 1.4l8.5 8.5L2 20.5c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3l8.5-8.5 8.5 8.5c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L13.4 12z';
      path['m'] =
        'M32 0C14.4 0 0 14.4 0 32s14.4 32 32 32 32-14.4 32-32S49.6 0 32 0zm0 62C15.5 62 2 48.5 2 32S15.5 2 32 2s30 13.5 30 30-13.5 30-30 30zm1.4-30l12.4-12.4c.4-.4.4-1 0-1.4s-1-.4-1.4 0L32 30.6 19.6 18.2c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4L30.6 32 18.2 44.4c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3L32 33.4l12.4 12.4c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L33.4 32z';
      break;
    case 'success':
      path['xs'] =
        'M8.3 22.2c-.3 0-.6-.1-.8-.4L.2 12.6c-.4-.4-.3-1.1.2-1.4.4-.4 1.1-.3 1.4.2l6.5 8.2L22.2 2.2c.4-.4 1-.5 1.4-.2.4.4.5 1 .2 1.4L9.1 21.8c-.2.2-.5.4-.8.4z';
      path['m'] =
        'M32 0C14.4 0 0 14.4 0 32s14.4 32 32 32 32-14.4 32-32S49.6 0 32 0zm0 62C15.5 62 2 48.5 2 32S15.5 2 32 2s30 13.5 30 30-13.5 30-30 30zm-4.8-16.3c-.3 0-.6-.1-.8-.4l-9.7-12.1c-.3-.4-.3-1.1.2-1.4.4-.3 1.1-.3 1.4.2l8.9 11.1 18.6-23.2c.3-.4 1-.5 1.4-.2.4.3.5 1 .2 1.4L27.9 45.3c-.1.2-.4.4-.7.4z';
      break;
    default:
      // info -> prepared, but not used by now
      path['xs'] = path['m'] =
        'M32 0C14.4 0 0 14.4 0 32s14.4 32 32 32 32-14.4 32-32S49.6 0 32 0zm0 62C15.5 62 2 48.5 2 32S15.5 2 32 2s30 13.5 30 30-13.5 30-30 30z M32 46.9c-.6 0-1-.4-1-1V25.3c0-.6.4-1 1-1s1 .4 1 1v20.6c0 .6-.4 1-1 1zm0-29.6c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5c0-.4.2-.8.5-1.1.3-.3.6-.4 1-.4z';
      break;
  }

  return createToast(
    <div className={styles.wrapper}>
      <div className={styles.iconWrapper}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={styles.svgXs}>
          <path fillRule="evenodd" fill="currentColor" d={path['xs']} />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" className={styles.svgXs}>
          <path fill="currentColor" fillRule="evenodd" d={path['m']} />
        </svg>
      </div>
      <div className={styles.textWrapper}>{msg}</div>
    </div>,
    options
  );
}
